import PaymentInstructionLayout from "../layouts/PaymentInstructionLayout";
import { useState } from "react";
import { Copy, Check, ChevronDown, ChevronUp } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
// import CountDownTimer from "./CountDownTimer";
// import formatCurrency from "../../utils/numberFormatter";
import METHOD_LOGOS from "./MethodLogos";

export default function PaymentInstructionQRIS({
  amount,
  orderId,
  merchantName,
  expired_at,
  selected_method,
  onCheckStatus,
  qrString,
}) {
  const [copied, setCopied] = useState(false);
  const [activeSection, setActiveSection] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(qrString);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  const instructions = [
    "Scan atau screenshot QR code",
    "Buka aplikasi bank/dompet digital (Gojek, OVO, Dana, QRIS BCA, dll).",
    "Pilih 'Pay' atau 'Scan'",
    "Upload tangkapan layar (hasil screenshot) QR Code.",
    "Masukkan kode PIN dompet digitalmu.",
    "Jika pembayaran telah selesai dan berhasil, kamu akan mendapat notifikasi.",
  ];

  return (
    <PaymentInstructionLayout
      amount={amount}
      orderId={orderId}
      merchantName={merchantName}
      expiredAt={expired_at}
      selectedMethod={selected_method}
      onCheckStatus={onCheckStatus}
      paymentCredential={
        <div className="mt-4 mb-10 text-center">
          <div className="flex items-center gap-2 justify-center">
            <span className="font-bold">Please scan </span>
            <img
              src={METHOD_LOGOS["QRIS"] || "/placeholder.svg"}
              className="h-12 w-12 object-contain"
              alt="QRIS Logo"
            />
          </div>
          <QRCodeSVG value={qrString} size={256} className="mx-auto rounded-lg" />
        </div>
      }
      howToPay={
        <div className="space-y-4 mt-6">
          <h3 className="text-xl font-bold">How to Pay</h3>
          <div className="border border-gray-200 rounded-lg overflow-hidden">
            <button
              className="w-full p-4 flex items-center justify-between bg-gray-50 hover:bg-gray-100"
              onClick={() => setActiveSection(!activeSection)}
            >
              <span className="font-medium">Step-by-step Instructions</span>
              {activeSection ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
            </button>
            {activeSection && (
              <div className="p-4 bg-white border-t border-gray-200">
                <ol className="list-inside space-y-2 text-gray-600">
                  {instructions.map((step, index) => (
                    <li key={index}>
                      {index + 1}. {step}
                    </li>
                  ))}
                </ol>
              </div>
            )}
          </div>
        </div>
      }
    />
  );
}
